/* eslint-disable global-require */
import { useTranslation } from 'react-i18next';

import EmptyHeatmapsImage from '@hotjar/shared-assets/images/empty-heatmaps.png';

import { EmptyStateCard } from './EmptyStateCard';

export const HeatmapsEmptyStateCard = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <EmptyStateCard
      img={EmptyHeatmapsImage}
      title={t('activation:empty-states.heatmaps.pending-title')}
    >
      {t('activation:empty-states.heatmaps.pending-message')}
    </EmptyStateCard>
  );
};
